import React from "react";
import { withRouter } from "react-router-dom";

import mixpanel from "../../../lib/mixPanel";

const handleClick = (event, onClickButton, section) => {
  if (onClickButton) {
    if (section) {
      onClickButton(section);
    } else {
      onClickButton(event);
    }
  }
};
const link = (
  title,
  href,
  location,
  defaultClass,
  onClickButton,
  section,
  itemCount
) => {
  const isActive = location.pathname === href;
  return (
    <li className={(defaultClass && defaultClass) || ""}>
      <a
        href={href}
        onClick={event => handleClick(event, onClickButton, section)}
        className={(isActive && "active") || ""}
      >
        {(defaultClass && defaultClass === "nav-points" && (
          <i className="icon icon-wallet-white" />
        )) ||
          ""}
        {(defaultClass && defaultClass === "basket-header" && (
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="14"
              viewBox="0 0 22 21"
            >
              <g fill="#1fb6ff" fillRule="nonzero">
                <path d="M10.768 17.533c0-1.26-1.054-2.284-2.357-2.288-1.303-.004-2.364 1.012-2.372 2.274-.009 1.26 1.038 2.291 2.341 2.303a2.406 2.406 0 0 0 1.687-.662c.449-.43.701-1.016.701-1.627zm-3.352 0c0-.527.442-.955.987-.955.546 0 .988.428.988.955 0 .528-.442.956-.988.956a1.005 1.005 0 0 1-.713-.272.94.94 0 0 1-.297-.684h.023zM18.598 17.533c0-1.264-1.06-2.289-2.365-2.289-1.306 0-2.365 1.025-2.365 2.29 0 1.263 1.059 2.288 2.365 2.288 1.306 0 2.365-1.025 2.365-2.289zm-3.353 0c0-.527.442-.955.988-.955.545 0 .987.428.987.955 0 .528-.442.956-.987.956-.546 0-.988-.428-.988-.956zM19.746 2.689H4.959l-.046-.222C4.734 1.414 3.87.595 2.778.444L1.01.178a.703.703 0 0 0-.696.21.65.65 0 0 0-.11.699c.104.233.337.39.6.402l1.768.244c.498.073.889.451.964.934l1.561 9.555c.217 1.408 1.468 2.45 2.939 2.445h10.608c.38 0 .688-.299.688-.667a.678.678 0 0 0-.688-.667H8.059c-.789-.001-1.46-.557-1.584-1.31l-.07-.423H16.6c1.472-.003 2.726-1.038 2.962-2.444l.872-5.69a.652.652 0 0 0-.166-.53.7.7 0 0 0-.522-.225V2.69zm-1.562 6.267c-.113.763-.787 1.33-1.584 1.333H6.176l-1.01-6.267h13.776l-.758 4.934z" />
              </g>
            </svg>
          </div>
        )) ||
          ""}
        {title}
        {itemCount && <span>{itemCount}</span>}
      </a>
      {(defaultClass && defaultClass === "dropdown" && (
        <div className="dropdown-menu">
          <ul>
            <li>
              <a
                href="/profile?edit"
                onClick={() => mixpanel.track("Account Tab Click")}
              >
                Profile
              </a>
            </li>
            <li>
              <a
                href="/profile?orders"
                onClick={() => mixpanel.track("Orders Tab Click")}
              >
                Orders
              </a>
            </li>
            <li>
              <a href="/profile?promotions">Promotions</a>
            </li>
            <li>
              <a href="/profile?addresses">Your Addresses</a>
            </li>
            <li>
              <a href="/profile?favorites">Your Favorites</a>
            </li>
            <li>
              <a href="/profile?payments">Payment Methods</a>
            </li>
            <li>
              <a href="/profile?rewards">Rewards</a>
            </li>
            <li>
              <a
                onClick={() => handleClick(event, onClickButton, section)}
                href="javascript: void(0)"
                className="logout"
              >
                Logout
              </a>
            </li>
          </ul>
        </div>
      )) ||
        ""}
    </li>
  );
};

const NavbarLink = ({
  title,
  href,
  location,
  privateRoute,
  authed,
  defaultClass,
  onClickButton,
  section,
  itemCount
}) => {
  // eslint-disable-next-line
  let auth = authed || (window && window.authed);
  if (typeof auth !== "boolean") {
    return <div />;
  }
  if (!privateRoute && auth) return <noscript />;
  else if (!privateRoute && !auth)
    return link(
      title,
      href,
      location,
      defaultClass,
      onClickButton,
      section,
      itemCount
    );
  else if (privateRoute && !auth) return <noscript />;
  else
    return link(
      title,
      href,
      location,
      defaultClass,
      onClickButton,
      section,
      itemCount
    );
};

export default withRouter(NavbarLink);
